import(/* webpackMode: "eager", webpackExports: ["DashboardLayout"] */ "/opt/buildhome/repo/apps/personal-web/components/dashboard-layout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HomeContent"] */ "/opt/buildhome/repo/apps/personal-web/components/home-content.tsx");
